*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: block;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.4;
}

.option-label {
  cursor: pointer;
  user-select: none;

  overflow: hidden;
  display: flex;
  gap: 8px;
  align-items: center;

  box-sizing: border-box;
  height: 32px;
  padding: 0 8px;
  border-radius: calc(infinity * 1px);

  font-size: var(--wui-font-size, 14px);
  color: var(--wui-color-text, #1b1b1b);
  text-overflow: ellipsis;
  white-space: nowrap;

  transition:
    color var(--wui-duration-feedback, 100ms) var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1)),
    background-color var(--wui-duration-feedback, 100ms) var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1));
}

.check {
  display: var(--wui-option-check-display, block);
  flex-shrink: 0;
}

.content-wrap {
  overflow: hidden;
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host(:not([selected])) .check {
  visibility: hidden;
}

::slotted([slot='prefix']),
::slotted([slot='suffix']) {
  flex-shrink: 0;
}

.option-label:focus-visible {
  outline: var(--wui-focus-ring-width, 3px) solid var(--wui-color-focus-ring, rgb(0 136 255 / 0.4));
  outline-offset: 2px;
}

:host([active]) .option-label {
  color: var(--wui-color-on-accent, #fff);
  background: var(--wui-color-accent, #08f);
}

@media (hover: hover) and (pointer: fine) {
  .option-label:hover {
    color: var(--wui-color-on-accent, #fff);
    background: var(--wui-color-accent, #08f);
  }
}

:host([disabled]) .option-label {
  cursor: not-allowed;
}
